export const RutasActionTypes = {
  API_RESPONSE_SUCCESS: '@@rutas/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@rutas/API_RESPONSE_ERROR',

  GET_RUTA: '@@rutas/GET_RUTA',
  LIST_RUTAS: '@@rutas/LIST_RUTAS',
  ADD_RUTA: '@@rutas/ADD_RUTA',
  UPDATE_RUTA: '@@rutas/UPDATE_RUTA',
  DELETE_RUTA: '@@rutas/DELETE_RUTA',
  SET_FILTER: '@@rutas/SET_FILTER',

  RESET: '@@rutas/RESET'
}
